import { createSelector } from 'reselect'

import { prodButtons, telcoButtons, devButtons } from './buttonsConfig'

import { RootState } from '~/core/store/root.reducer'
import selectFeatureFlags from '~/featureFlags/store/featureFlags.selectors'

const getSaleFlow = (state: RootState) => state.saleFlow

const getSaleForms = (state: RootState) => state.saleForms

const getEnv = (_: RootState, env: string) => env

const selectSaleForms = createSelector(getSaleForms, (forms) => forms.forms)

export const selectSaleFlow = createSelector(getSaleFlow, (saleFlow) => saleFlow)

export const selectSaleFlowType = createSelector(
  getSaleFlow,
  ({ technology, product, lineType }) => {
    return { technology, product, lineType }
  },
)

export const selectCanContinue = createSelector(selectSaleForms, (forms) => {
  return Object.values(forms).every((form) => Object.values(form).every((field) => !!field.isValid))
})
export const selectTechnology = createSelector(selectSaleFlow, (saleFlow) => saleFlow.technology)

export const selectProductSegment = createSelector(selectSaleFlow, (saleFlow) => saleFlow.product)

export const selectLineType = createSelector(selectSaleFlow, (saleFlow) => saleFlow.lineType)

export const selectIsPro = createSelector(selectProductSegment, (product) => product === 'pro')

export const selectIsPostpaid = createSelector(
  selectLineType,
  (lineType) => lineType === 'postpaid',
)

export const selectIsCartera = createSelector(selectSaleFlow, (saleFlow) => saleFlow.isCartera)

export const selectShouldValidate = createSelector(getSaleForms, (forms) => forms.shouldValidate)

export const selectShouldScroll = createSelector(selectSaleForms, (forms) => {
  return Object.values(forms).every((form) =>
    Object.values(form).every((field) => field.isValidating === false),
  )
})

export const selectIsCustomerValid = createSelector(selectSaleForms, (forms) => {
  return forms.mainLine.customer?.isValid
})

export const selectButtonsConfig = createSelector(selectFeatureFlags, getEnv, (flags, env) => {
  if (env === 'production') {
    return flags.isTelco ? telcoButtons : prodButtons
  }
  return devButtons
})

export default selectSaleFlow
